module.exports = __webpack_public_path__ + "static/media/Sofia-Pro-Light.3f8448c2.ttf";